import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { createNotification } from "../../../shared/store/notifications";

export const getCheckInEventLink = async (params) => {
  const res = await axios.middleware("/Social.asmx/ResgataLink", {
    params,
  });

  return res[0].data;
};
export const useCheckInEventLink = ({ config, eventType, eventId } = {}) => {
  const params = {
    type: eventType.toUpperCase(),
    id: eventId,
  };
  return useQuery({
    ...config,
    queryKey: ["checkInEventLink", params],
    queryFn: () => getCheckInEventLink(params),

    // onSettled: () => {
    //   createNotification({ type: "error", message: "teste" });
    // },
  });
};
